export default "__VITE_ASSET__DzGvJt0x__ 480w, __VITE_ASSET__DgxSkY7U__ 768w, __VITE_ASSET__47VtZt7d__ 1200w, __VITE_ASSET__ChsqrKEA__ 1600w";